import useBottomSheet from 'hooks/common/useBottomSheet';
import { LoginMethodData, LoginProvider } from 'types/bottomsheet';

const PROVIDERS: Record<LoginProvider, { icon: string; label: () => string }> = {
  google: { icon: '/imgweb/login/google_logo.png', label: () => brsc.google_signin_button_text },
  apple: { icon: '/imgweb/login/apple_logo.png', label: () => brsc.apple_signin_button_text },
  email: { icon: '/imgweb/login/email_link_logo.png', label: () => brsc.email_signin_button_text },
};

/** 로그인 방식 선택. 버튼 모양은 main.css 의 .login-button */
const LoginMethod = () => {
  const { sheets, closeWithAnimation } = useBottomSheet();
  const sheet = sheets.LoginMethod;
  const { providers, onSelect } = sheet.data as LoginMethodData;

  const select = (provider: LoginProvider) => {
    // 로그인 팝업은 클릭 이벤트 안에서 열어야 브라우저가 막지 않으므로 닫기 전에 바로 호출한다
    onSelect(provider);
    closeWithAnimation(sheet.id, { data: provider });
  };

  return (
    <div className="flex w-full flex-col">
      {providers.map((provider) => (
        <div key={provider} className={`login-button ${provider} flexcenter`} onClick={() => select(provider)}>
          <img src={PROVIDERS[provider].icon} alt="" />
          <span>{PROVIDERS[provider].label()}</span>
        </div>
      ))}
    </div>
  );
};

export default LoginMethod;
